import { useCallback } from 'react';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../../../server';
import * as actions from '../../../store/actions';
import { DOCUMENT_DATA_TAG } from '../../../constants';
import { useDynamicReducerDispatch } from '../../../store';

export const useFetchPlayerTags = () => {
    const translate = useComponentTranslations();
    const { showComponentError } = useComponentMethods();
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback(async () => {
        const response = await server.getPlayerTags({
            tagNames: [DOCUMENT_DATA_TAG]
        });
        const { tags } = response.data;
        const documentData = tags.find((tag) => tag.name === DOCUMENT_DATA_TAG);

        if (!documentData) {
            showComponentError(translate('documentData.not-defined'));
            return;
        }

        try {
            const data = JSON.parse(documentData.value);

            dynamicReducerDispatch(actions.setDocumentData(data));
        } catch (error) {
            showComponentError(translate('documentData.error'));
        }
    }, [
        dynamicReducerDispatch,
        showComponentError,
        translate
    ]);
};
